import { Tabs, Tab } from "@mui/material";

export default function LanguageTabs({
  langs = [],
  value = 0,
  onChange,
  ariaLabel = "language tabs",
  idPrefix = "language-tab",
  ...tabsProps
}) {
  return (
    <Tabs value={value} onChange={onChange} aria-label={ariaLabel} {...tabsProps}>
      {langs.map((lang, i) => (
        <Tab
          key={lang.value}
          label={lang.label}
          id={`${idPrefix}-${i}`}
          aria-controls={`${idPrefix}-panel-${i}`}
        />
      ))}
    </Tabs>
  );
}
